// extracted by mini-css-extract-plugin
export default {"top":"PayerTableRow_top_F1pHC","icons":"PayerTableRow_icons_SR0dX","icon":"PayerTableRow_icon_vjL37","bidder":"PayerTableRow_bidder_N1v1O","payer":"PayerTableRow_payer_lmVYu"};